import { MaskService } from './mask.service';
import * as $ from 'jquery';

export default class FormMaskService {

    static initMasks() {
        $('input[data-pb-inputmask]').each((i, inp) => {
            let el = $(inp);
            MaskService.createMask(`input[name="${el.attr('name')}"]`, el.attr('data-pb-inputmask'), () => {
                //el.removeClass('error');
                //el.removeAttr('data-mask-invalid');
            }, () => {
                //el.addClass('error');
                //el.attr('data-mask-invalid', 1);
            }
            );
        });

    }
}
